export const supportedCountries = [
    {
        label: 'USA',
        value: 'US',
    },
] as const;

export const defaultCountry = supportedCountries[0];
